import { useCallback, useState } from 'react';

/**
 * Hides a flow error while the field it belongs to is being corrected. The auth
 * controllers keep their error until the next request, so without this the line
 * describing a value the user has already started fixing stays under the field.
 * Submitting shows errors again, a repeat of the same one included.
 */
const useDismissibleError = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  return {
    isDismissed,
    dismiss: useCallback(() => setIsDismissed(true), []),
    restore: useCallback(() => setIsDismissed(false), []),
  };
};

export { useDismissibleError };
